import React from 'react';
import { NavigateFunction } from 'react-router';
import { CellContext } from '@tanstack/react-table';

import AdaptiveTableCell from '@components/common/AdaptiveTableCell';

import { TDashboardAssetTypeSummaryPerOrganization } from '@interfaces/platform/platformDashboard';

import { routes } from '@constants/routes';
import { columnSizes } from '@constants/table';

import ViewOrganizationTableCell from '../ViewOrganizationTableCell';

const { adminPanel: { index, organisations } } = routes;

interface IAssetsColumnsProps {
	navigate: NavigateFunction;
}

export const getAssetTypesPerOrganizationColumns = ({ navigate }: IAssetsColumnsProps) => ([
	{
		header: 'Organisation',
		accessorKey: 'organizationName',
		size: columnSizes.size160,
		cell: ({ row }: CellContext<TDashboardAssetTypeSummaryPerOrganization, any>) => {
			const { organizationName, organizationId, logo } = row?.original || {};

			const { id } = logo || {};

			const openOrganisationProfile = () => {
				if (!organizationId) return;

				navigate(`${index}${organisations}/organisation-profile/${organizationId}`);
			};

			return (
				<ViewOrganizationTableCell
					avatarId={id}
					onClick={openOrganisationProfile}
					text={organizationName}
					tooltipLabel='Company profile'
				/>
			);
		},
	},
	{
		header: 'Assets',
		accessorKey: 'quantity',
		size: columnSizes.size160,
		cell: ({ row }: CellContext<TDashboardAssetTypeSummaryPerOrganization, any>) => {
			const value = row.original?.quantity;

			return <AdaptiveTableCell text={value.toString()} />;
		},
	},
]);
